import React, { FC, useContext } from "react";
import Select from "Components/GMS/Select";
import { OPERATORS } from "Common/GlobalConstant";
import { CSContext } from "../contexts/CSContext";


const CSAttributeMapping
    : FC = (props: any) => {
        const { pivotList, handlePivotListChange, attributeList, category, handleRowDelete, getWeightageSum, handleAdd } = useContext(CSContext)
        return (
            <>
                {
                    pivotList?.map((x: PivotType, index: number) => (
                        <div 
                            id={`pivot-row-${index}`} 
                            className="tw-flex tw-m-5" 
                            key={index}
                        >
                            <div id={`pivot-row-${index}-pivot-attribute-container`} className="tw-w-[25%] tw-mr-4">
                                <label id={`pivot-row-${index}-pivot-attribute-label`} className="tw-ml-5 tw-mb-2">Pivot Attribute</label>
                                <Select
                                    id={`pivot-row-${index}-pivot-attribute-select`}
                                    onChange={(e) => {
                                        handlePivotListChange(e, index, "pivot");
                                    }}
                                    value={x?.pivot_attribute}
                                    options={attributeList}
                                    name={"Select Attribute"}
                                    disabled={category ? false : true}
                                    hideLabel={true}
                                    isSearchable
                                />
                            </div>
                            <div id={`pivot-row-${index}-operator-container`} className="tw-w-[10%] tw-mr-4">
                                <label id={`pivot-row-${index}-operator-label`} className="tw-ml-5 tw-mb-2">Operator</label>
                                <Select
                                    id={`pivot-row-${index}-operator-select`}
                                    onChange={(e) => {
                                        handlePivotListChange(e, index, "operator");
                                    }}
                                    value={
                                        x?.operator !== "" ? x?.operator : OPERATORS[0]?.value
                                    }
                                    options={OPERATORS}
                                    name={""}
                                    disabled={category ? false : true}
                                    hideLabel={true}
                                />
                            </div>
                            <div id={`pivot-row-${index}-base-attribute-container`} className="tw-w-[25%] tw-mr-4">
                                <label id={`pivot-row-${index}-base-attribute-label`} className="tw-ml-5 tw-mb-2">Base Attribute</label>
                                <Select
                                    id={`pivot-row-${index}-base-attribute-select`}
                                    onChange={(e) => {
                                        handlePivotListChange(e, index, "base");
                                    }}
                                    value={x?.base_attribute}
                                    options={attributeList}
                                    name={"Select Attribute"}
                                    disabled={category ? false : true}
                                    hideLabel={true}
                                    isSearchable
                                />
                            </div>
                            <div id={`pivot-row-${index}-weightage-container`} className="tw-w-[25%]">
                                <label id={`pivot-row-${index}-weightage-label`} className="tw-ml-5 tw-mb-2 ">Weightage</label>
                                <div>
                                    <input
                                        id={`pivot-row-${index}-weightage-input`}
                                        type="number"
                                        className="tw-h-9.5 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border  tw-border-neutral-300 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-ml-4 tw-placeholder-gray-dark "
                                        value={x?.weightage}
                                        placeholder="Enter Percentage"
                                        onChange={(e) => {
                                            handlePivotListChange(e, index, "weight");
                                        }}
                                        disabled={category ? false : true}
                                    />
                                </div>
                            </div>
                            <div id={`pivot-row-${index}-delete-container`} className="tw-m-5 tw-w-6 tw-h-6">
                                <button
                                    id={`pivot-row-${index}-delete-btn`}
                                    className={`tw-w-6 tw-h-6 tw-left-0 tw-top-0  ${index <= 0
                                        ? "tw-bg-gray-50"
                                        : "tw-bg-white tw-border-blue-800"
                                        }  tw-rounded tw-shadow tw-border  tw-mt-3`}
                                    onClick={() => {
                                        handleRowDelete(index);
                                    }}
                                    disabled={index <= 0}
                                >
                                    -
                                </button>
                            </div>
                            <div id={`pivot-row-${index}-add-container`} className="tw-mt-5 tw-w-6 tw-h-6">
                                <button
                                    id={`pivot-row-${index}-add-btn`}
                                    className={`tw-w-6 tw-h-6 tw-left-0 tw-top-0 ${getWeightageSum() >= 100
                                        ? "tw-bg-gray-50"
                                        : "tw-bg-white tw-border-blue-800"
                                        }    tw-rounded tw-shadow tw-border  tw-mt-3`}
                                    onClick={() => handleAdd(index)}
                                    disabled={getWeightageSum() >= 100}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    ))}
            </>
         );
    };

export default CSAttributeMapping;
